import { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  db,
  collection,
  getDocs,
  deleteDoc,
  doc,
  query,
  orderBy,
} from '../../firebase';
import MessageItem from './MessageItem';
import DeleteForm from './DeleteForm';

const MessageList = ({ refreshTrigger }) => {
  const [messages, setMessages] = useState([]);
  const [target, setTarget] = useState({
    id: null,
    storedPassword: null,
  });
  const [password, setPassword] = useState('');
  const [isActive, setActive] = useState(false);
  const [checkMessage, setCheckMessage] = useState('');

  const resetValue = () => {
    setActive(false);
    setPassword('');
    setTarget({
      id: null,
      storedPassword: null,
    });
    setCheckMessage('');
  };

  const handleCloseButton = () => {
    setActive(false);
    resetValue();
  };

  const handleDeleteButton = (id, storedPassword) => {
    setActive(true);
    setTarget({ id: id, storedPassword: storedPassword });
  };

  const handleDeleteMessage = async (e) => {
    e.preventDefault();
    if (password !== target.storedPassword) {
      setCheckMessage('비밀번호가 일치하지 않습니다.');
      return;
    } else {
      try {
        await deleteDoc(doc(db, 'weddingMessages', target.id));
        setMessages(messages.filter((msg) => msg.id !== target.id));
        resetValue();
      } catch (error) {
        console.error('메시지 삭제 오류:', error);
      }
    }
  };

  useEffect(() => {
    const fetchMessages = async () => {
      const messagesQuery = query(
        collection(db, 'weddingMessages'),
        orderBy('date', 'desc'),
      );

      const querySnapshot = await getDocs(messagesQuery);

      const messagesArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setMessages(messagesArray);
    };

    fetchMessages();
  }, [refreshTrigger]);

  return (
    <StyledSection>
      <h3 className="a11y-hidden">메시지 목록</h3>
      {messages.length > 0 ? (
        <StyledUl>
          {messages.map((msg) => (
            <MessageItem
              key={msg.id}
              message={msg}
              deleteMessage={handleDeleteButton}
            />
          ))}
        </StyledUl>
      ) : (
        <StyledP>
          아직 메시지가 없습니다.
          <br />
          축하 메시지를 남겨주세요. 💌
        </StyledP>
      )}
      {isActive && (
        <DeleteForm
          password={password}
          setPassword={setPassword}
          onSubmit={handleDeleteMessage}
          onCancel={handleCloseButton}
          checkMessage={checkMessage}
        />
      )}
    </StyledSection>
  );
};

const StyledSection = styled.section`
  width: 100%;
  max-width: 500px;
  margin: auto;
  overflow-x: auto;
`;

const StyledUl = styled.ul`
  display: flex;
  gap: 1rem;
  padding: 0 2rem;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none
  scroll-snap-type: x mandatory

  &::-webkit-scrollbar {
    display: none;
  }

  & > li {
    flex-shrink: 0;
    scroll-snap-align: start;
  }
`;

const StyledP = styled.p`
  text-align: center;
  font-size: 1.6rem;
  line-height: 2.4rem;
`;

export default MessageList;
